import {
  type UpdateUserPasswordRequest,
  type UpdateUserRequest,
} from "../../../core/backend/clients/backendClient";
import { backendService } from "../../../core/backend/services/backendService";

class ProfileService {
  updateUser(request: UpdateUserRequest) {
    return backendService.createBackendClient().apiUserPut(request);
  }

  updatePassword(request: UpdateUserPasswordRequest) {
    return backendService.createBackendClient().apiUserUpdatePassword(request);
  }

  deleteUser() {
    return backendService.createBackendClient().apiUserDelete();
  }
}

export const profileService = new ProfileService();
